import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import type { TabsParamList } from './types';
import FloatingTabBar from '../components/nav/FloatingTabBar';
// P3-6 PROFILE group: the real Profile tab screen.
import ProfileScreen from '../screens/ProfileScreen';
// P3-2 FEED/HOME group: the real Home feed screen.
import HomeScreen from '../app/(tabs)/home';
// P3 DIRECT MESSAGES group: the real Chat tab (DM list + segments).
import ChatScreen from '../app/(tabs)/chat';
// Discover tab: the existing discover hub screen (search + communities/trending),
// imported as-is — it also stays registered at the root as 'Search' for
// navigate('Search') callers. Communities is folded in here (no longer a tab).
import SearchScreen from '../screens/SearchScreen';
// Learn tab (centre): the learning center.
import LearnScreen from '../screens/LearnScreen';
// Create flow: no Create tab and NO permanent edge chrome. An Instagram-style
// right-edge left-swipe on Home interactively slides in the FULL-SCREEN
// CreateHub (Post / Story / Article mode switcher); a brief hint pill shows on
// the first 2 Home visits per install only.
import CreateSwipeGesture from '../components/create/CreateSwipeGesture';

const Tab = createBottomTabNavigator<TabsParamList>();

// Home wrapped AT THE NAVIGATOR LEVEL (home.tsx interior untouched — screen
// agents own it): the wrapper adds the right-edge create swipe + CreateHub.
// Module-level so the component identity is stable across re-renders.
function HomeWithCreateSwipe() {
  return (
    <CreateSwipeGesture>
      <HomeScreen />
    </CreateSwipeGesture>
  );
}

// P2: custom glass tab bar. `tabBarStyle.position:'absolute'` makes react-navigation
// stop reserving layout space for the bar so screen content scrolls behind the
// glass (each screen pads its scroller via useTabBarClearance / layout.bottomNavInset).
// FloatingTabBar reads route.name (PascalCase) to pick icons + the Chat DM badge.
//
// 5-TAB LAYOUT (client reference): Home · Communities · DISCOVER (centre) ·
// Chat · Profile.
export function Tabs() {
  return (
    <Tab.Navigator
      tabBar={(props) => <FloatingTabBar {...props} />}
      // detachInactiveScreens uses react-native-screens' ScreenContainer, whose
      // native RNSScreenNavigationContainer is NOT registered on the New Arch
      // (Fabric) → "View config not found for RNSScreenNavigationContainer" render
      // error the moment the authed Tabs tree mounts. Disabling it makes the tab
      // container plain Views (no native detach container) — renders correctly.
      detachInactiveScreens={false}
      screenOptions={{
        headerShown: false,
        tabBarStyle: { position: 'absolute' },
      }}
    >
      <Tab.Screen name="Home" component={HomeWithCreateSwipe} />
      {/* Discover — left of centre. Hosts the discover hub (SearchScreen): search
          + Communities/Trending/People. Communities is folded in here and is no
          longer its own tab; the Communities SCREEN stays a pushable root route
          reached from Discover + Home's "See all". */}
      <Tab.Screen
        name="Discover"
        component={SearchScreen}
        options={{ title: 'Discover' }}
      />
      {/* Learn — the CENTRE tab (learning center). */}
      <Tab.Screen
        name="Learn"
        component={LearnScreen}
        options={{ title: 'Learning Center' }}
      />
      {/* No "Create" tab: the create flow is the Home edge swipe → full-screen
          CreateHub → CreatePost / StoryCreate root-stack modals. */}
      <Tab.Screen name="Chat" component={ChatScreen} />
      <Tab.Screen name="Profile" component={ProfileScreen} options={{ title: 'You' }} />
    </Tab.Navigator>
  );
}
